export const LAKESIDE_SITE_TOKEN = "8ea48625-af50-42d7-869e-0f3a970a9785";
